import {useState} from "react"
import useCallback from "./useCallback";

export default function useVersion(initialVersion = 0) {
	const [version, setVersion] = useState(initialVersion || 0);
	const upgrade = useCallback(() => setVersion(version => version + 1));
	return [version, upgrade, setVersion];
}